export default "__VITE_ASSET__DNUYqmyw__"